(() => {
  const bar = document.getElementById("dmStickyAtc");
  if (!bar) return;

  const btn = document.getElementById("dmStickyAtcBtn");
  const priceEl = document.getElementById("dmStickyAtcPrice");
  const mobileText = document.getElementById("dmStickyAtcMobileText");

  // Mobiel direct zichtbaar, desktop pas na ~15% scroll
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const SHOW_AFTER_SCROLL_RATIO = isMobile ? 0 : 0.15;

  const getScrollRatio = () => {
    const doc = document.documentElement;
    const scrollTop = window.pageYOffset || doc.scrollTop || 0;
    const scrollHeight = (doc.scrollHeight || 0) - window.innerHeight;
    if (scrollHeight <= 0) return 0;
    return scrollTop / scrollHeight;
  };

  const throttle = (fn, wait) => {
    let last = 0;
    return (...args) => {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn(...args);
      }
    };
  };

  const onScroll = throttle(() => {
    const ratio = getScrollRatio();
    if (ratio >= SHOW_AFTER_SCROLL_RATIO) bar.classList.add("is-visible");
    else bar.classList.remove("is-visible");
  }, 60);

  const getSelectedVariantId = () => {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return bar.dataset.initialVariantId;
  };

  const updateMobileLineByNLTime = () => {
    if (!mobileText) return;

    const parts = new Intl.DateTimeFormat("nl-NL", {
      timeZone: "Europe/Amsterdam",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    const hh = Number(parts.find(p => p.type === "hour")?.value || "0");
    const mm = Number(parts.find(p => p.type === "minute")?.value || "0");
    const minutes = hh * 60 + mm;

    mobileText.textContent = (minutes < 15 * 60) ? "Vandaag verzonden" : "Gratis verzending";
  };

  const syncPrice = () => {
    const themePrice =
      document.querySelector(".price .price-item--regular") ||
      document.querySelector(".price .price-item") ||
      document.querySelector(".product__price .money") ||
      document.querySelector("[data-price]");

    if (themePrice && priceEl) {
      priceEl.textContent = themePrice.textContent.replace(/[€]/g, "").trim();
    }
  };

  const addToCartAndRedirect = async (variantId) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!res.ok) {
      console.error("Add to cart failed", await res.text());
      return;
    }

    window.location.href = "/cart";
  };

  btn?.addEventListener("click", async () => {
    const variantId = getSelectedVariantId();
    if (!variantId) return;

    btn.disabled = true;
    try {
      await addToCartAndRedirect(variantId);
    } finally {
      btn.disabled = false;
    }
  });

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!t) return;

    if (t.matches('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]')) {
      syncPrice();
    }
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  updateMobileLineByNLTime();
  setInterval(updateMobileLineByNLTime, 60 * 1000);

  syncPrice();
  onScroll();
})();
